import script from "./TableLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableLoading.vue?vue&type=script&setup=true&lang=ts"

import "./TableLoading.vue?vue&type=style&index=0&id=a06d25fe&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a06d25fe"]])

export default __exports__